import { decryptFile, encryptFile, exportKeyAsHex } from "../dataEncryption";
import { createEmptyLogsAndVars, recordVariable, ReportingError } from "../diagnostics/clientErrors";
import { apiVersion } from "./dwcommonutils";
import { encodeSendObjectToBase58 } from "./jwtcomm";
import { baseUrl } from "./dwcommonutils";
import { reevaluateFileMimeType } from "../mimetype";
import { getMyFilesListJwt, myWriteFileJwt, myReadFileJwt, getMyFileStat, myFileExistsJwt, myRemoveFileJwt, myCopyFile, myMoveFile, getMyFileMetadataJwt, setMyFileMetadata, determineIsChunked, readFileInChunksAsReadableStream, myReadFileInChunksToWritable, } from "./dwstorageutils";
import { loadJwt } from "./localstorage/jwtStorage";
import { splitPath } from "../paths";
/**
 * The storage endpoint has returned both a bare array and an `{ entries }`
 * object over its lifetime. Keep the desktop wrapper's public shape stable
 * instead of silently treating a valid array response as an empty storage.
 */
export const normalizeFilesListResult = (result) => {
    if (Array.isArray(result))
        return { entries: result };
    if (result && Array.isArray(result.entries))
        return result;
    throw new Error("Invalid storage files list response");
};
/**
 * Rebuild a decrypted storage blob as a useful File. The stream-based desktop
 * download path cannot retain the encrypted response's MIME type, so infer it
 * from the path (or the bytes when there is no known extension).
 */
export const createTypedStorageFile = async (path, blob) => {
    const pathParts = splitPath(path);
    const file = new File([blob], pathParts?.name ?? "file.bin", {
        type: blob.type || "application/octet-stream",
    });
    return await reevaluateFileMimeType(path, file);
};
export class FileExistsError extends Error {
    filePath;
    constructor(filePath) {
        super(`File exists: ${filePath}`);
        this.name = "FileExistsError";
        this.filePath = filePath;
    }
}
export class FileWriteError extends Error {
    filePath;
    constructor(filePath) {
        super(`File write error: ${filePath}`);
        this.name = "FileWriteError";
        this.filePath = filePath;
    }
}
export class FileUnzipError extends Error {
    filePath;
    constructor(filePath) {
        super(`File unzip failed: ${filePath}`);
        this.name = "FileUnzipError";
        this.filePath = filePath;
    }
}
export const getFilesList = async (props, path, recurse) => {
    /*if (
      props.portalClientId !== undefined &&
      props.clientSessionToken !== undefined &&
      props.ed25519UserShare !== undefined
    ) {*/
    // TODO make it cleaner
    const authToken = await loadJwt();
    const result = await getMyFilesListJwt(authToken ?? "", path, recurse);
    return normalizeFilesListResult(result);
    //return await getMyFilesList(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path, recurse);
    /*} else {
      const logsAndVars = createEmptyLogsAndVars("dwstorage:getFilesList");
      recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
      recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
      recordVariable(logsAndVars, "path", path);
      recordVariable(logsAndVars, "recurse", recurse);
      throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }*/
};
export const writeFile = async (provider, props, path, file, onProgress) => {
    /*if (
      props.portalClientId !== undefined &&
      props.clientSessionToken !== undefined &&
      props.ed25519UserShare !== undefined
    ) {*/
    // TODO make it cleaner
    const authToken = await loadJwt();
    const encryptedFile = await encryptFile(provider, file);
    return await myWriteFileJwt(authToken ?? "", path, encryptedFile, onProgress);
    //return await myWriteFile(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path, file);
    /*} else {
      const logsAndVars = createEmptyLogsAndVars("dwstorage:writeFile");
      recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
      recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
      recordVariable(logsAndVars, "path", path);
      recordVariable(logsAndVars, "file", file);
      throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }*/
};
export const readFile = async (provider, props, path, size, onProgress) => {
    /*if (
      props.portalClientId !== undefined &&
      props.clientSessionToken !== undefined &&
      props.ed25519UserShare !== undefined
    ) {*/
    // TODO make it cleaner
    const authToken = (await loadJwt()) ?? "";
    return readFileJwt(provider, authToken, path, size, onProgress);
    //return await myReadFile(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path);
    /*} else {
      const logsAndVars = createEmptyLogsAndVars("dwstorage:readFile");
      recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
      recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
      recordVariable(logsAndVars, "path", path);
      throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }*/
};
export const getDownloadUrl = async (provider, props, fileName, path, size, onProgress) => {
    /*if (
      props.portalClientId !== undefined &&
      props.clientSessionToken !== undefined &&
      props.ed25519UserShare !== undefined
    ) {*/
    // TODO make it cleaner
    const authToken = (await loadJwt()) ?? "";
    return getDownloadUrlJwt(provider, authToken, fileName, path, size, onProgress);
    //return await myReadFile(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path);
    /*} else {
      const logsAndVars = createEmptyLogsAndVars("dwstorage:readFile");
      recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
      recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
      recordVariable(logsAndVars, "path", path);
      throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }*/
};
export const readFileJwt = async (provider, authToken, path, size, onProgress) => {
    const { writableStream, getBlob } = createBlobWritableStream();
    //  const writer = writableStream.getWriter();
    const progressData = {
        fileId: path,
        status: "downloading",
        loadedFiles: 0,
        totalFiles: 1,
        loadedFilesBytes: 0,
        totalFilesBytes: size,
        size: size,
    };
    await readFileJwtToWritable(provider, authToken, path, progressData, writableStream, onProgress);
    //  await writer.close();
    //await writableStream.close();
    const finalBlob = getBlob();
    // The writable stream collects decrypted chunks and therefore loses the
    // response's Content-Type. Mark it as unknown binary first so
    // reevaluateFileMimeType can infer the real type from the storage path (and,
    // for extensionless files, from the decrypted bytes). Without this step a
    // storage image/PDF arrives as a typeless File and cannot be rendered as an
    // inline call preview.
    return await createTypedStorageFile(path, finalBlob);
    //if (path.includes("~$")) {
    //  throw new DOMException("Simulated network failure", "NetworkError");
    //} else {
    /*const isChunked = await determineIsChunked(authToken ?? "", path);
    console.log(isChunked);
    let decryptedFile;
    if (isChunked) {
      decryptedFile = await myReadFileInChunks(provider, authToken ?? "", path, onProgress);
    } else {
      const encryptedFile = await myReadFileJwt(authToken ?? "", path, onProgress);
      decryptedFile = await decryptFile(provider, encryptedFile);
    }
    const typedFile = await reevaluateFileMimeType(path, decryptedFile);
    return typedFile;*/
    //}
};
export const getDownloadUrlJwt = async (provider, authToken, fileName, path, size, onProgress) => {
    const userKey = await exportKeyAsHex(provider);
    const sendObject = {
        path: path,
        fileName: fileName,
        userEncryptionKey: userKey,
    };
    const endpoint = `/api/${apiVersion}/files-mobile/read`;
    const url = baseUrl + endpoint;
    const message = encodeSendObjectToBase58(sendObject);
    const downloadUrl = url + "?authToken=" + authToken + "&message=" + message;
    return downloadUrl;
};
function createBlobWritableStream() {
    const chunks = [];
    const writableStream = new WritableStream({
        write(chunk) {
            chunks.push(chunk); // Collect chunks
        },
        close() {
            console.log("Stream closed, Blob is ready.");
        },
    });
    return { writableStream, getBlob: () => new Blob(chunks, { type: "application/octet-stream" }) };
}
export const readFileJwtToWritable = async (provider, authToken, path, progressData, writable, onProgress) => {
    const isChunked = await determineIsChunked(authToken ?? "", path);
    console.log(isChunked);
    if (isChunked) {
        await myReadFileInChunksToWritable(provider, authToken ?? "", path, progressData, writable, onProgress);
    }
    else {
        const encryptedFile = await myReadFileJwt(authToken ?? "", path, (progress) => {
            if (onProgress) {
                onProgress({
                    fileId: progressData.fileId,
                    status: "downloading",
                    loaded: progress.loaded,
                    total: progress.total,
                    estimated: undefined,
                    loadedFiles: progressData.loadedFiles,
                    totalFiles: progressData.totalFiles,
                    loadedFilesBytes: progressData.loadedFilesBytes,
                    totalFilesBytes: progressData.totalFilesBytes,
                });
            }
        });
        const decryptedFile = await decryptFile(provider, encryptedFile);
        const typedFile = await reevaluateFileMimeType(path, decryptedFile);
        await typedFile.stream().pipeTo(writable);
    }
};
export const readFileJwtAsReadable = async (provider, authToken, path, size, progressData, onProgress, signal) => {
    const isChunked = await determineIsChunked(authToken ?? "", path, signal);
    if (isChunked) {
        return readFileInChunksAsReadableStream(provider, authToken ?? "", path, size, progressData, onProgress, signal);
    }
    else {
        const encryptedFile = await myReadFileJwt(authToken ?? "", path, (progress) => {
            if (onProgress) {
                onProgress({
                    fileId: progressData.fileId,
                    status: "downloading",
                    loaded: progress.loaded,
                    total: progress.total,
                    estimated: undefined,
                    loadedFiles: progressData.loadedFiles,
                    totalFiles: progressData.totalFiles,
                    loadedFilesBytes: progressData.loadedFilesBytes,
                    totalFilesBytes: progressData.totalFilesBytes,
                });
            }
        }, signal);
        signal?.throwIfAborted();
        const decryptedFile = await decryptFile(provider, encryptedFile);
        signal?.throwIfAborted();
        const typedFile = await reevaluateFileMimeType(path, decryptedFile);
        signal?.throwIfAborted();
        return typedFile.stream();
    }
};
/*export const myReadFileInChunks = async (
  provider: EIP1193Provider,
  authToken: string,
  path: string,
  onProgress?: (progressEvent: AxiosProgressEvent) => void,
): Promise<File> => {
  const { writableStream, getBlob } = createBlobWritableStream();
  const writer = writableStream.getWriter();
  const progressData = {
    fileId: path,
    status: "downloading",
    loadedFiles,
    totalFiles,
    loadedFilesBytes,
    totalFilesBytes,
  }
  myReadFileInChunksToWritable(provider, authToken, path, {}, writableStream, onProgress);
  writer.close();
  const finalBlob = getBlob();
  const pathParts = splitPath(path);
  return new File([finalBlob], pathParts?.name ?? "file.bin");
};*/
export const getFileStat = async (props, path) => {
    if (props.portalClientId !== undefined &&
        props.clientSessionToken !== undefined &&
        props.ed25519UserShare !== undefined) {
        return await getMyFileStat(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path);
    }
    else {
        const logsAndVars = createEmptyLogsAndVars("dwstorage:getFileStat");
        recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
        recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
        recordVariable(logsAndVars, "path", path);
        throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }
};
export const fileExists = async (props, path) => {
    /*if (
      props.portalClientId !== undefined &&
      props.clientSessionToken !== undefined &&
      props.ed25519UserShare !== undefined
    ) {*/
    // TODO make it cleaner
    const authToken = await loadJwt();
    return await myFileExistsJwt(authToken ?? "", path);
    //return await myFileExists(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path);
    /*} else {
      const logsAndVars = createEmptyLogsAndVars("dwstorage:fileExists");
      recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
      recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
      recordVariable(logsAndVars, "path", path);
      throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }*/
};
export const removeFile = async (props, path) => {
    /*if (
      props.portalClientId !== undefined &&
      props.clientSessionToken !== undefined &&
      props.ed25519UserShare !== undefined
    ) {*/
    // TODO make it cleaner
    const authToken = await loadJwt();
    return await myRemoveFileJwt(authToken ?? "", path);
    //return await myRemoveFile(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path);
    /*} else {
      const logsAndVars = createEmptyLogsAndVars("dwstorage:removeFile");
      recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
      recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
      recordVariable(logsAndVars, "path", path);
      throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }*/
};
export const copyFile = async (props, path, newPath) => {
    if (props.portalClientId !== undefined &&
        props.clientSessionToken !== undefined &&
        props.ed25519UserShare !== undefined) {
        return await myCopyFile(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path, newPath);
    }
    else {
        const logsAndVars = createEmptyLogsAndVars("dwstorage:copyFile");
        recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
        recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
        recordVariable(logsAndVars, "path", path);
        recordVariable(logsAndVars, "newPath", newPath);
        throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }
};
export const moveFile = async (props, path, newPath) => {
    if (props.portalClientId !== undefined &&
        props.clientSessionToken !== undefined &&
        props.ed25519UserShare !== undefined) {
        return await myMoveFile(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path, newPath);
    }
    else {
        const logsAndVars = createEmptyLogsAndVars("dwstorage:moveFile");
        recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
        recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
        recordVariable(logsAndVars, "path", path);
        recordVariable(logsAndVars, "newPath", newPath);
        throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }
};
export const getFileMetadata = async (props, path) => {
    /*if (
      props.portalClientId !== undefined &&
      props.clientSessionToken !== undefined &&
      props.ed25519UserShare !== undefined
    ) {*/
    // TODO make it cleaner
    const authToken = await loadJwt();
    return await getMyFileMetadataJwt(authToken ?? "", path);
    //return await getMyFileMetadata(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path);
    /*} else {
      const logsAndVars = createEmptyLogsAndVars("dwstorage:getFileMetadata");
      recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
      recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
      recordVariable(logsAndVars, "path", path);
      throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }*/
};
export const setFileMetadata = async (props, path, metadata) => {
    if (props.portalClientId !== undefined &&
        props.clientSessionToken !== undefined &&
        props.ed25519UserShare !== undefined) {
        return await setMyFileMetadata(props.portalClientId, props.clientSessionToken, props.ed25519UserShare, path, metadata);
    }
    else {
        const logsAndVars = createEmptyLogsAndVars("dwstorage:setFileMetadata");
        recordVariable(logsAndVars, "storageProps.portalClientId", props.portalClientId);
        recordVariable(logsAndVars, "storageProps.clientSessionToken", props.clientSessionToken);
        recordVariable(logsAndVars, "path", path);
        recordVariable(logsAndVars, "metadata", metadata);
        throw new ReportingError("MPC wallet is not yet set up.", logsAndVars);
    }
};
